import React from "react";
import { useNavigate } from "react-router-dom";

import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";

function CustomLink({ children, ...rest }) {
  return (
    <Link
      {...rest}
      component="button"
      underline="none"
      color="common.white"
      fontFamily="Montserrat"
      fontSize="0.9rem"
    >
      {children}
    </Link>
  );
}

function LogoBlock() {
  const navigate = useNavigate();

  const iconStyle = {
    cursor: "pointer",
  };

  return (
    <Stack alignItems="center" spacing={2}>
      <img
        src="/images/footer-logo.png"
        alt="footer-logo"
        height="75px"
        style={{ cursor: "pointer" }}
        onClick={() => navigate("/")}
      />

      <Stack spacing={2} direction="row">
        <img
          src="/images/linkedin-logo.png"
          alt="linkedin-logo"
          height="20px"
          style={iconStyle}
          onClick={() => {}}
        />
        <img
          src="/images/facebook-logo.png"
          alt="facebook-logo"
          height="20px"
          style={iconStyle}
          onClick={() =>
            window.open(
              "https://www.facebook.com/theenglishtreeTET",
              "_blank",
              "noopener,noreferrer",
            )
          }
        />
        <img
          src="/images/instagram-logo.png"
          alt="instagram-logo"
          height="20px"
          style={iconStyle}
          onClick={() => {}}
        />
        <img
          src="/images/youtube-logo.png"
          alt="youtube-logo"
          height="20px"
          style={iconStyle}
          onClick={() => {}}
        />
      </Stack>
    </Stack>
  );
}

function CoursesBlock() {
  const navigate = useNavigate();

  return (
    <Stack alignItems="flex-start" spacing={1}>
      <Typography variant="h6" color="common.white" align="center">
        Khoá học
      </Typography>
      <CustomLink onClick={() => navigate("/khoa-hoc/pho-thong-tieu-chuan")}>
        Khoá Phổ thông Tiêu chuẩn
      </CustomLink>
      <CustomLink onClick={() => navigate("/khoa-hoc/pho-thong-vip")}>
        Khoá Phổ thông VIP
      </CustomLink>
      <CustomLink onClick={() => navigate("/khoa-hoc/quoc-te-tieu-chuan")}>
        Khoá Quốc tế Tiêu chuẩn
      </CustomLink>
      <CustomLink onClick={() => navigate("/khoa-hoc/quoc-te-vip")}>
        Khoá Quốc tế VIP
      </CustomLink>
      <CustomLink onClick={() => navigate("/khoa-hoc/robotics-ai")}>
        Khoá Robotics & AI
      </CustomLink>
      <CustomLink
        onClick={() => navigate("/khoa-hoc/giao-tiep-giao-vien-nuoc-ngoai")}
      >
        Khoá Giao tiếp 1-1 với Giáo viên Nước ngoài
      </CustomLink>
      <CustomLink onClick={() => navigate("/khoa-hoc/thuc-chien")}>
        Câu lạc bộ Tiếng Anh Thực chiến
      </CustomLink>
    </Stack>
  );
}

function WhyUsBlock() {
  const navigate = useNavigate();

  return (
    <Stack alignItems="flex-start" spacing={1}>
      <Typography variant="h6" color="common.white" align="center">
        Điểm đặc biệt
      </Typography>
      <CustomLink
        onClick={() => navigate("diem-dac-biet?ddb=cong-thuc-bi-mat")}
      >
        40% - Công thức bí mật
      </CustomLink>
      <CustomLink
        onClick={() => navigate("diem-dac-biet?ddb=nguyen-lieu-chat-luong")}
      >
        20% - Nguyên liệu chất lượng
      </CustomLink>
      <CustomLink
        onClick={() => navigate("diem-dac-biet?ddb=chuyen-gia-tay-nghe-cao")}
      >
        20% - Chuyên gia tay nghề cao
      </CustomLink>
      <CustomLink
        onClick={() => navigate("diem-dac-biet?ddb=trang-tri-hai-hoa")}
      >
        10% - Trang trí hài hoà
      </CustomLink>
      <CustomLink onClick={() => navigate("diem-dac-biet?ddb=phuc-vu-chu-dao")}>
        10% - Phục vụ chu đáo
      </CustomLink>
    </Stack>
  );
}

function BenefitsBlock() {
  const navigate = useNavigate();

  return (
    <Stack
      alignItems="flex-start"
      spacing={1}
      style={{ cursor: "pointer" }}
      onClick={() => navigate("dac-quyen")}
    >
      <Typography variant="h6" color="common.white" align="center">
        Đặc quyền
      </Typography>
    </Stack>
  );
}

function CompanyBlock() {
  const navigate = useNavigate();

  return (
    <Stack alignItems="flex-start" spacing={1}>
      <Typography variant="h6" color="common.white" align="center">
        Về chúng tôi
      </Typography>
      <CustomLink onClick={() => navigate("gioi-thieu")}>Giới thiệu</CustomLink>
      <CustomLink onClick={() => navigate("blog")}>Blog</CustomLink>
    </Stack>
  );
}

function CareerBlock() {
  const navigate = useNavigate();

  return (
    <Stack alignItems="flex-start" spacing={1}>
      <Typography
        variant="h6"
        color="common.white"
        align="center"
        style={{ cursor: "pointer" }}
        onClick={() => navigate("tuyen-dung")}
      >
        Tuyển dụng
      </Typography>
    </Stack>
  );
}

function Footer() {
  return (
    <Stack
      alignItems="center"
      justifyContent="flex-end"
      spacing={6}
      padding={8}
      sx={{ backgroundColor: "info.main" }}
    >
      <Stack
        direction="row"
        justifyContent="center"
        alignItems="center"
        useFlexGap
        flexWrap="wrap"
        spacing={8}
      >
        <LogoBlock />
        <Stack
          direction="row"
          justifyContent="flex-start"
          alignItems="flex-start"
          useFlexGap
          flexWrap="wrap"
          spacing={8}
        >
          <CoursesBlock />
          <WhyUsBlock />
          <BenefitsBlock />
          <CompanyBlock />
          <CareerBlock />
        </Stack>
      </Stack>

      <Typography variant="body2" color="common.white" align="center">
        Copyright © The English Tree. All Rights Reserved.
      </Typography>
    </Stack>
  );
}

export default Footer;
